const formrules = {
  required: value => !!value || "Preenchimento obrigatório."
}

export {
  formrules
}